import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinmumbai() {



    const cardData =
    {
        keyword: 'Urbania On Rent in Mumbai',
        heading: 'Urbania on rent in pune: Urbania On Rent in Mumbai',
        headingDescription: 'Urbania On Rent in Pune extends premium and reliable Urbania On Rent in Mumbai services for travelers needing comfortable and spacious group transportation between Pune and Mumbai. Our well‑maintained Force Urbania fleet offers air‑conditioned comfort, generous seating, and smooth performance, making it ideal for corporate travel, airport transfers, family outings, weddings, sightseeing trips, and outstation journeys from Pune to Mumbai and vice versa. With professional chauffeurs, flexible one‑way and round‑trip rental options, and convenient doorstep pickup from key areas including Pune Airport, Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, and Pimpri Chinchwad, we ensure a safe, punctual, and stress‑free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for Urbania hire for Pune‑to‑Mumbai travel.',

        top: 'Top Places to Visit in Mumbai with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s iconic stone arch built to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, it stands as a historic entry point for British governors and a symbol of colonial-era architecture. Today, visitors enjoy ferry rides to Elephanta Island, street food stalls, coastal photography, and a lively promenade filled with tourists, performers, and vendors. Its illuminated evenings create a stunning waterfront ambiance that reflects the essence of Mumbai."
  },
  {
    "title": "Marine Drive (Queen’s Necklace)",
    "description": "Marine Drive is Mumbai’s famous 3.6 km-long coastline, known for its curved boulevard that glitters like a ‘Queen’s Necklace’ at night. The promenade is ideal for morning jogs, romantic walks, cycling, and enjoying refreshing sea breezes. The Art Deco buildings lining the stretch add heritage value, making it one of the world’s largest collections of Art Deco architecture. Sunsets here are especially mesmerizing, drawing locals, tourists, and photographers to soak in the city’s vibrant coastal charm."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT, a UNESCO World Heritage Site, is an architectural masterpiece blending Victorian Gothic Revival and Indian traditional designs. Built in 1887, it is one of India’s busiest railway stations and a symbol of Mumbai’s historic importance. Its grand domes, stained glass windows, carvings of flora and fauna, and intricate pillars make it a living museum. The nighttime lighting further enhances its majesty, making it a must-visit landmark for history, architecture, and photography enthusiasts."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular beach, famous for its vibrant street food culture, local entertainers, and stunning sunsets. Visitors indulge in Mumbai’s iconic snacks like pav bhaji, bhel puri, and gola while enjoying camel rides, kite flying, and beach sports. The beach is also frequently visited by Bollywood celebrities who live in the surrounding areas. Its lively yet relaxed atmosphere makes it a perfect escape for families, couples, and tourists."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Shree Siddhivinayak Temple in Prabhadevi is one of India’s most revered Ganesha temples, believed to fulfill devotees’ wishes. The temple’s wooden doors depict Ashtavinayak carvings, and the gold-plated sanctum adds to its spiritual aura. Thousands queue up daily for darshan, including celebrities and leaders. During Ganesh Chaturthi, the entire area comes alive with devotional music, lights, and vibrant processions, showcasing Mumbai’s deep spiritual culture."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, situated on an islet connected by a narrow causeway, is a stunning Indo-Islamic structure honoring Sufi saint Pir Haji Ali Shah Bukhari. Surrounded by the sea on all sides, it offers breathtaking views and a serene spiritual experience. The white marble structure, religious hymns, and peaceful setting attract visitors of all faiths. The walk to the dargah during low tide is a unique experience, blending spirituality with natural beauty."
  },
  {
    "title": "Elephanta Caves",
    "description": "The Elephanta Caves, a UNESCO World Heritage Site located on Elephanta Island, feature ancient rock-cut sculptures dedicated primarily to Lord Shiva. The 5th–8th century caves include magnificent carvings like the massive Trimurti (three-faced Shiva), Nataraja, and various mythological scenes. Visitors reach the island via ferry from the Gateway of India, experiencing a combination of history, art, nature, and coastal adventure."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a modern engineering marvel that connects Mumbai’s western suburbs to South Mumbai. Its cable-stayed architecture, sweeping curves, and views of the Arabian Sea make it a visual delight. The bridge significantly reduces travel time, symbolizing Mumbai’s modern urban growth. The best time to view the Sea Link is during sunrise, sunset, or night when the bridge lights create a spectacular skyline view."
  },
  {
    "title": "Chor Bazaar",
    "description": "One of India’s oldest and most famous flea markets, Chor Bazaar is known for its antique furniture, vintage Bollywood posters, cameras, gramophones, lamps, and rare collectibles. Walking through its busy lanes offers a glimpse into Mumbai’s historic trade culture. Bargain hunters, interior designers, and collectors frequent the area to discover unique treasures. It remains a buzzing hotspot for culture, photography, and old-world charm."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Spread over 100 sq km, Sanjay Gandhi National Park is Mumbai’s green lung and a biodiversity hotspot. Visitors enjoy nature trails, lion and tiger safaris, boating, cycling routes, and the ancient Kanheri Caves inside the park. Home to leopards, deer, monkeys, and hundreds of bird species, it offers a jungle retreat in the middle of the city. The park is perfect for trekking, wildlife photography, and peaceful nature escapes."
  },
  {
    "title": "Mount Mary Church",
    "description": "The Basilica of Our Lady of the Mount, popularly called Mount Mary Church, is located atop a hill in Bandra offering beautiful views of the sea. The church is known for its stunning Gothic architecture, peaceful interiors, and the annual Bandra Fair held in September. Devotees across religions visit to seek blessings, light candles, and enjoy the serene surroundings. It is one of Mumbai’s most significant spiritual and cultural landmarks."
  }
],



"services": [
    {
      "name": "Urbania on Rent in Mumbai",
      "description": "Urbania on Rent in Mumbai provides fully air-conditioned Urbania vehicles for city travel, family outings, corporate trips, and leisure journeys. Each vehicle is maintained to high standards and driven by professional chauffeurs to ensure safe, comfortable, and convenient travel across Mumbai."
    },
    {
      "name": "Mumbai Urbania Bus Hire",
      "description": "Mumbai Urbania Bus Hire offers spacious air-conditioned buses for group tours, corporate events, school trips, and social gatherings. Comfortable seating and experienced drivers make every journey reliable, safe, and enjoyable."
    },
    {
      "name": "Urbania Rental Service Mumbai",
      "description": "Urbania Rental Service Mumbai delivers premium Urbania vehicles suitable for family trips, sightseeing, corporate travel, and leisure outings. Professional chauffeurs ensure convenient, safe, and dependable transportation throughout Mumbai and nearby destinations."
    },
    {
      "name": "Urbania AC Bus on Rent Mumbai",
      "description": "Urbania AC Bus on Rent Mumbai provides fully air-conditioned buses for long-distance travel, group tours, and corporate outings. Spacious interiors and trained chauffeurs ensure a smooth and comfortable journey."
    },
    {
      "name": "Corporate Urbania Hire Mumbai",
      "description": "Corporate Urbania Hire Mumbai offers professional transportation services for office trips, employee commutes, and corporate events. Punctual service and experienced chauffeurs ensure smooth, reliable, and professional travel solutions."
    },
    {
      "name": "Urbania for Outstation Mumbai",
      "description": "Urbania for Outstation Mumbai provides safe and comfortable long-distance travel with air-conditioned vehicles. Experienced drivers make trips to nearby cities, tourist destinations, and corporate locations convenient and enjoyable."
    },
    {
      "name": "Urbania Airport Transfer Mumbai",
      "description": "Urbania Airport Transfer Mumbai ensures timely pickups and drops for domestic and international airports. Spacious vehicles and professional chauffeurs provide convenient, safe, and stress-free airport transportation."
    },
    {
      "name": "Luxury Urbania Mumbai",
      "description": "Luxury Urbania Mumbai offers high-end air-conditioned Urbania vehicles with plush interiors for VIP travel, weddings, and executive trips. Chauffeurs ensure a premium, stylish, and comfortable travel experience."
    },
    {
      "name": "Affordable Urbania Hire Mumbai",
      "description": "Affordable Urbania Hire Mumbai provides budget-friendly Urbania rental services without compromising on comfort or reliability. Ideal for families, groups, and corporate clients seeking value-for-money travel."
    },
    {
      "name": "Chauffeur Driven Urbania Mumbai",
      "description": "Chauffeur Driven Urbania Mumbai ensures stress-free travel with trained, verified chauffeurs. Fully air-conditioned vehicles provide smooth, safe, and comfortable journeys for all passengers."
    },
    {
      "name": "Urbania for Wedding Events Mumbai",
      "description": "Urbania for Wedding Events Mumbai offers elegant air-conditioned vehicles for weddings, guest transport, and family travel. Professional chauffeurs ensure timely, stylish, and hassle-free transportation."
    },
    {
      "name": "Urbania for Corporate Travel Mumbai",
      "description": "Urbania for Corporate Travel Mumbai delivers dependable and stylish transportation for business trips, corporate tours, and executive meetings. Punctual service with professional drivers ensures seamless corporate travel."
    },
    {
      "name": "Best Urbania Rental Mumbai",
      "description": "Best Urbania Rental Mumbai provides top-rated Urbania rental services known for reliability, vehicle quality, and customer satisfaction. Suitable for corporate travel, family trips, and group outings requiring premium transportation."
    },
    {
      "name": "Urbania Group Travel Mumbai",
      "description": "Urbania Group Travel Mumbai offers organized and comfortable transportation for group tours, corporate outings, and social events. Fully air-conditioned buses with professional chauffeurs ensure safe, convenient, and enjoyable group travel."
    },
    {
      "name": "Reliable Urbania Hire Mumbai",
      "description": "Reliable Urbania Hire Mumbai provides trustworthy, punctual, and safe Urbania rental services. Air-conditioned vehicles with trained chauffeurs ensure convenient, comfortable, and dependable travel for all passengers."
    }
  ],
  "tableData": [
    ["Urbania on Rent in Mumbai", "Mumbai Urbania Bus Hire"],
    ["Urbania Rental Service Mumbai", "Urbania AC Bus on Rent Mumbai"],
    ["Corporate Urbania Hire Mumbai", "Urbania for Outstation Mumbai"],
    ["Urbania Airport Transfer Mumbai", "Luxury Urbania Mumbai"],
    ["Affordable Urbania Hire Mumbai", "Chauffeur Driven Urbania Mumbai"],
    ["Urbania for Wedding Events Mumbai", "Urbania for Corporate Travel Mumbai"],
    ["Best Urbania Rental Mumbai", "Urbania Group Travel Mumbai"],
    ["Reliable Urbania Hire Mumbai", ""]
  ],



"whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania On Rent in Mumbai",
        "WhyChoosedescription": "Urbania On Rent in Mumbai is perfect for group travel, corporate trips, family outings, wedding guest transport, and outstation journeys, offering comfort and spacious seating."
    },
    {
        "WhyChooseheading": "Luxury and Spacious Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania On Rent in Mumbai provides well-maintained Force Urbania vehicles with modern interiors, air-conditioning, and ample legroom for a smooth and comfortable travel experience."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Urbania On Rent in Mumbai comes with skilled and courteous drivers familiar with Mumbai routes, highways, and nearby areas, ensuring safe and punctual travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Choose Urbania On Rent in Mumbai for competitive rates with no hidden charges, making group, corporate, and family travel budget-friendly."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania On Rent in Mumbai provides round-the-clock booking assistance and support for inquiries, reservations, and last-minute travel requirements."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Urbania On Rent in Mumbai is available for hourly rentals, full-day bookings, corporate trips, wedding transportation, airport transfers, and customized packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All vehicles provided for Urbania On Rent in Mumbai are regularly cleaned, sanitized, and serviced to ensure passenger safety and comfort."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania On Rent in Mumbai guarantees on-time pickups and dependable service for stress-free travel experiences."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania On Rent in Mumbai available for local and outstation travel?',
        answer: 'Yes, Urbania On Rent in Mumbai can be booked for city travel, corporate trips, family outings, and long-distance journeys.',
    },
    {
        question: 'How can I book Urbania On Rent in Mumbai?',
        answer: 'You can book Urbania On Rent in Mumbai via phone, WhatsApp, or online for fast and hassle-free reservations.',
    },
    {
        question: 'Why choose Urbania On Rent in Mumbai?',
        answer: 'Urbania On Rent in Mumbai offers spacious seating, professional drivers, clean vehicles, and transparent pricing for corporate, family, and group travel.',
    },
    {
        question: 'Are drivers experienced?',
        answer: 'Yes, all drivers for Urbania On Rent in Mumbai are trained, licensed, and experienced in providing safe and comfortable travel.',
    },
    {
        question: 'Can I customize pickup and drop-off locations?',
        answer: 'Absolutely. Urbania On Rent in Mumbai allows flexible pickup and drop locations across Mumbai and nearby areas.',
    },
    {
        question: 'Is Urbania On Rent in Mumbai available 24x7?',
        answer: 'Yes, Urbania On Rent in Mumbai operates 24x7 to meet your travel needs anytime.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all Urbania vehicles are regularly cleaned, sanitized, and maintained to ensure passenger safety and comfort.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Urbania On Rent in Mumbai accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during trips?',
        answer: 'Yes, dedicated customer support is available throughout your journey for smooth and stress-free travel.',
    },
    {
        question: 'Can Urbania be used for corporate, family, and outstation trips?',
        answer: 'Yes, Urbania On Rent in Mumbai is ideal for corporate travel, family outings, airport transfers, and group or outstation journeys.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ramesh Mehta',
        feedback: 'Urbania On Rent in Mumbai made our group trip very comfortable and enjoyable. Spacious, clean, and reliable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Priya Sharma',
        feedback: 'We hired Urbania On Rent in Mumbai for a corporate outing. Excellent service and professional driver.',
        rating: 5,
    },
    {
        id: 3,
        name: 'Mr. Ashwin Desai',
        feedback: 'Urbania On Rent in Mumbai provided smooth and hassle-free travel for our family trip. Highly recommended.',
        rating: 5,
    },
];























































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent in Mumbai",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-mumbai.jpg",
  "description": "Urbania On Rent in Mumbai offers AC and non-AC Urbania buses for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. Chauffeur-driven buses ensure safe, comfortable, and convenient transportation in Mumbai and surrounding areas.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-on-rent-mumbai"
  }
};






    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania On Rent in Mumbai | AC & Luxury Urbania Bus Hire 
  </title>

  <meta
    name="description"
    content="Book Urbania On Rent in Mumbai for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. AC and non-AC Urbania buses with chauffeur-driven service ensure safe, comfortable, and convenient transportation in Mumbai."
  />

  <meta
    name="keywords"
    content="Urbania on Rent in Mumbai, Mumbai Urbania Bus Hire, Urbania Rental Service Mumbai, Urbania AC Bus on Rent Mumbai, Corporate Urbania Hire Mumbai, Urbania for Outstation Mumbai, Urbania Airport Transfer Mumbai, Luxury Urbania Mumbai, Affordable Urbania Hire Mumbai, Chauffeur Driven Urbania Mumbai, Urbania for Wedding Events Mumbai, Urbania for Corporate Travel Mumbai, Best Urbania Rental Mumbai, Urbania Group Travel Mumbai, Reliable Urbania Hire Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/64.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaonrentinmumbai;